<button
  type="button"
  [class.warning]="alert"
  class="alert btn btn-secondary btn-medium alert-dismissible fade show">
  <span
    class="d-flex align-items-center spacing-8 tag-open"
    (click)="isOpen = !isOpen"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    cdkConnectedOverlayPanelClass="example-panel">
    <span class="left-icon btn-icon h3-reg filter-type">
      <app-ce-icon [name]="tag.icon" [svg_class]="['primary-50']"></app-ce-icon>
      {{ tag.name }}:</span
    >
    @if (!tag.filter_value) {
      <span
        class="tag-value h3-bold"
        [matTooltip]="tag.filter_value"
        [matTooltipPosition]="'right'"
        >{{ tag.filterValue }}</span
      >
    }
    <span
      class="tag-value h3-bold"
      [matTooltip]="tag.filter_value"
      [matTooltipPosition]="'right'"
      >{{ tag.filter_value }}</span
    >
  </span>
  <span class="close-btn" (click)="onRemove()">
    <img
      data-bs-dismiss="alert"
      aria-hidden="true"
      aria-label="Close"
      alt=""
      src="/assets/cancel.svg" />
  </span>
  <ng-template
    cdkConnectedOverlay
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayHasBackdrop]="true"
    (detach)="isOpen = false"
    (backdropClick)="isOpen = false"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayPositions]="[
      {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
      },
    ]"
    [cdkConnectedOverlayFlexiblePositionStrategy]="true">
    <ng-content></ng-content
  ></ng-template>
</button>
